import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsDate, IsEnum, IsNumber, IsOptional } from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

import { EDevicePoolSourceKind } from './security.enums';

export class DevicePool extends BasicEntity {
  @ApiProperty()
  @IsEnum(EDevicePoolSourceKind, { groups: ['error'] })
  @Index()
  @Column({ type: 'varchar', enum: EDevicePoolSourceKind, nullable: false })
  sourceKind: EDevicePoolSourceKind;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  rootUserId: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  memberCount: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Index()
  @Column({ type: 'int', nullable: false, default: 0 })
  linkStrengthMilli: number;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  lastRecomputedAt?: Date | null;
}
